import { CustomPickListValues } from "../models";

export class CustomPickList {
    Id: number | null;
    Tenant: number;
    Name: string;
    Code: string;
    IsExternal: boolean;
    CustomPickListValues: CustomPickListValues[];
}